export interface SocietyClientDataForm {
    id?: number;
    society_id?: number;
    client_id?: number;
    business_name_id?: number; // Para crear nuevo cliente desde razón social
    is_active?: boolean;
    
    // Datos del cliente (desde AllClientSerializer)
    client?: {
        id?: number;
        rut?: string;
        business_name?: string; // Ahora viene como string desde SerializerMethodField
        address?: string;
        country?: string;
        first_name_contact?: string;
        last_name_contact?: string;
        second_last_name_contact?: string;
        email_contact?: string;
        phone_code_contact?: string;
        phone_contact?: string;
        is_active?: boolean;
        name?: string; // Campo calculado del serializer
    };
    
    // Datos de la sociedad (desde AllSocietySerializer)
    society?: {
        id?: number;
        rut?: string;
        business_name?: string; // SerializerMethodField
        address?: string;
        country?: string;
        first_name_contact?: string;
        last_name_contact?: string;
        second_last_name_contact?: string;
        email_contact?: string;
        phone_code_contact?: string;
        phone_contact?: string;
        is_active?: boolean;
    };
}

export interface SocietyClientFilters {
    society_id?: number;
    name?: string;
    page: number;
    per_page: number;
    sort: string;
    order: string;
    rut?: string; // Para compatibilidad con filtros existentes
    business_name?: string; // Para compatibilidad con filtros existentes
}

export const defaultSocietyClientDataForm: SocietyClientDataForm = {
    society_id: 0,
    is_active: true
};
